module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HwMIt1/images/cover.jpg?1684515201222",
      "alt": "This image is the cover for the book Women's Voices and the Practice of Preaching"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Women's Voices and the Practice of Preaching\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Expert, practical help for women who preach or lead worship")]), _c('br'), _c('br'), _vm._v(" Many women preachers and worship leaders have trouble speaking; they struggle to fully use their physical voices. Maintaining that there is often a disconnect between the woman's self-understanding as a preacher and her own body, Nancy Lammers Gross presents not only techniques but also a theologically empowering paradigm shift to help women fully embody their God-given preaching vocations."), _c('br'), _c('br'), _vm._v(" Grounding her work in the biblical story of Miriam, Gross begins with a discussion of how women are instrumental in the work of God. She then tells stories, including her own, of women's experiences in losing connection to their bodies and their physical voices. Finally, Gross presents a constructive resolution with exercises for discovering and developing a full-body voice.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy Lammers Gross, Lillian Daniel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0